var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"header__dropdown-close",attrs:{"type":"button","aria-label":"Untermenü schließen"},on:{"click":function($event){return _vm.close()}}},[_vm._v(" Zurück ")])}
var staticRenderFns = []

export { render, staticRenderFns }